// extracted by mini-css-extract-plugin
module.exports = {"flip":"home-hero-module--flip--1IYSA","link":"home-hero-module--link--2b7MW"};